import { Component } from 'react';

import { createNewHeaders, updateHeaders, executeGet, executePost } from '../../functions/Kubuku';
import { LIST_ETALASE, CUD_ETALASE, CUD_OUTLET } from '../../api';

import QRCode from "react-qr-code";
import ModalSettings from '../../components/ModalSettings';
import ModalLoading from "../../components/ModalLoading";
import ModalPopup from "../../components/ModalPopup";

import {
    useParams,
    useNavigate
} from "react-router-dom";

class Outlet extends Component {

    constructor(props) {
        super(props)
        this.state = {
            param: this.props.params,
            currentPage: 1,
            showMain: false,
            showModal: false,
            isLoading: false,
            showLoading: false,
            data: '',
            msg: '',
            judul: '',
            deskripsi: '',
            id: '',
            flagListEtalase: false,
            flagOutlet: true,
            statusoutlet:0
        }
    }

    componentDidMount() {
        console.log("setting etalase = " + this.state.param.id);
        this.getEtalase();
    }

    scriptLoaded() {
        console.log("script load");
        // window.A.sort();
    }

    getEtalase = async () => {
        try {
            this.setState({
                isLoading: true
            })
            const flagOpen = localStorage.getItem('flagOpen');
            console.log("flagOpen = " + flagOpen);
            if(flagOpen != "1") {
                createNewHeaders('', ''); 
            } else {
                updateHeaders('', ''); 
            }
            const json = await executeGet(LIST_ETALASE + this.state.param.id);
            console.log("etalase = " + JSON.stringify(json));
            if (json.code == 200) {
                this.setState({ 
                    data: json.data, 
                    showMain: true, 
                    id: json.id,
                    judul: json.judul,
                    deskripsi: json.deskripsi,
                    isLoading: false
                });
            } else if (json.code == 404) {
                //masukkan tgl lahir
                // this.setState({ flagData: false, msg: json.msg });
            } else if (json.code == 500 || json.code == 505) {
                window.location.href = window.location.origin + "/login";
            }
        } catch (error) {
            //console.log(error);
            this.setState({ isError: true, errorMessage: "Network Error!" });
        }
    }

    updateOutlet = async () => {
        // console.log("param update = " + JSON.stringify(param));
        this.setState({ isLoading: true });
        try {
            let formData = new FormData();
            formData.append("id", this.state.id);
            formData.append("judul", this.state.judul);
            formData.append("deskripsi", this.state.deskripsi);

            const json = await executePost(CUD_OUTLET, formData);
            console.log("update_outlet = " + JSON.stringify(json));
            if (json.code == 200) {
                this.setState({ isLoading: false, isModal: true, msg: 'Berhasil Update Outlet' });
                this.getEtalase();
            }
        } catch (error) {
            //console.log(error);
            this.setState({ isError: true, errorMessage: "Network Error!" });
        }
    }

    deleteEtalase = async (param) => {
        console.log("param del = " + JSON.stringify(param));
        this.setState({ isLoading: true });
        try {
            let formData = new FormData();
            formData.append("id", param.id);
            formData.append("judul", param.judul);
            formData.append("deskripsi", param.deskripsi);
            formData.append("aktif", 9);
            formData.append("kode_beranda", this.state.param.id);

            const json = await executePost(CUD_ETALASE, formData);
            console.log("delete_etalase = " + JSON.stringify(json));
            if (json.code == 200) {
                this.setState({ isLoading: false, isModal: true, msg: 'Berhasil Delete Outlet' });
                this.getEtalase();
            }
        } catch (error) {
            //console.log(error);
            this.setState({ isError: true, errorMessage: "Network Error!" });
        }
    }

    onShare = async (url) => {
        const title = document.title;
        /*
        const url = document.querySelector("link[rel=canonical]")
          ? document.querySelector("link[rel=canonical]").href
          : document.location.href;*/
        const text = "Silahkan buka link di atas.";
        try {
            await navigator
            .share({
              title,
              url,
              text
            })
            
              /*
                Show a message if the user shares something
              */
              //alert(`Thanks for Sharing!`);
          } catch (err) {
             /*
                This error will appear if the user cancels the action of sharing.
              */
             alert(`Couldn't share ${err}`);
          }
      }

    outletMaster() {
        this.setState({flagOutlet:true, flagListEtalase: false});
    }

    listEtalase() {
        this.setState({flagOutlet:false, flagListEtalase:true});
    }

    render() {
        return (
            <div>
                {
                    this.state.isLoading &&
                    <ModalLoading />
                }
                {
                    this.state.isModal &&
                    <ModalPopup
                        type="success"
                        messages={this.state.msg}
                        press={() => { this.setState({ isModal: false }) }}
                    />
                }
                {
                    this.state.showModal &&
                    <ModalSettings
                        tipe="add_etalase"
                        kodeBeranda={this.state.param.id}
                        namaBeranda={this.state.param.name}
                        close={() => {
                            this.setState({ showModal: false });
                            this.getEtalase();
                        }}
                    />
                }
                {
                    this.state.showMain &&
                    <div className="dark:bg-white border rounded-2xl md:p-[30px] p-[15px] mb-20">
                        <div className="text-[24px] font-semibold dark:text-black">Pengaturan Konten</div>
                        <div className="text-[16px] font-semibold dark:text-grayWalangDark pb-3">{this.state.param.name}</div>
                        <ul className="flex flex-wrap text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:border-gray-700 dark:text-gray-400">
                                <li className="mr-2">
                                    <a onClick={() => this.outletMaster()} className={this.state.flagOutlet ? "cursor-pointer inline-block p-4 text-greenWalang bg-gray-100 rounded-t-lg active dark:bg-gray-800 dark:text-blue-500" : "cursor-pointer inline-block p-4 rounded-t-lg hover:text-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800 dark:hover:text-gray-300"}>Data Outlet</a>
                                </li>
                                <li className="mr-2">
                                    <a onClick={() => this.listEtalase()} className={this.state.flagListEtalase ? "cursor-pointer inline-block p-4 text-greenWalang bg-gray-100 rounded-t-lg active dark:bg-gray-800 dark:text-blue-500" : "cursor-pointer inline-block p-4 rounded-t-lg hover:text-gray-600 hover:bg-gray-50 dark:hover:bg-gray-800 dark:hover:text-gray-300"}>List Etalase</a>
                                </li>
                                
                            </ul>
                        { this.state.flagOutlet && 
                            <div className="relative p-1 flex-auto">
                                <form>
                                    <div className="mb-6">
                                        <label for="judul" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-800">Nama Outlet</label>
                                        <input type="text" id="judul" value={this.state.judul} onChange={event => this.setState({ judul: event.target.value })} className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-50 dark:border-gray-600 dark:placeholder-gray-400 dark:text-gray-900 dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light" placeholder="Masukkan Nama Outlet" required />
                                    </div>
                                    <div className="mb-6">
                                        <label for="deskripsi" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-800">Deskripsi Outlet</label>
                                        <input type="text" id="deskripsi" value={this.state.deskripsi} onChange={event => this.setState({ deskripsi: event.target.value })} className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-50 dark:border-gray-600 dark:placeholder-gray-400 dark:text-gray-900 dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light" placeholder="Masukkan Deskripsi Outlet" required />
                                    </div>
                                </form>
                                <div className="flex justify-end items-end">
                                    <button onClick={this.updateOutlet} type="button" className="md:w-[20%] w-[50%] bg-greenWalang rounded-full text-sm px-1 py-1 text-center inline-flex items-center dark:focus:ring-[#3b5998]/55 justify-center mr-2 hover:shadow-[0_8px_25px_-8px_#8e8e8e]">
                                        <div className="text-[#ffffff] text-md py-2">
                                            Update Outlet
                                        </div>
                                    </button>
                                </div>

                            </div>
                        }
                        { this.state.flagListEtalase && 
                            <div className="pt-8">
                                <button onClick={() => { this.setState({ showModal: true }) }} type="button" className="bg-greenWalang font-medium rounded-full text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-[#3b5998]/55 justify-center mr-2 hover:shadow-[0_8px_25px_-8px_#8e8e8e]">
                                    <div className="text-[#ffffff] pr-4">
                                        Tambah List Etalase
                                    </div>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 17V7" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
                                        <path d="M7 12L17 12" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
                                    </svg>
                                </button>
                                <div>
                                    <div className="text-[24px] font-semibold dark:text-black mt-4">Daftar List Etalase</div>
                                    <div className='grid grid-cols-1 gap-x-1 gap-y-1  md:gap-x-2 md:gap-y-2 md:grid-cols-4 md:mx-2 px-4 md:px-0 mt-1'>
                                        {this.state.data.map(item => {
                                            return (
                                                <div className="rounded-[12px] shadow bg-white lg:p-6 p-2 relative">
                                                    <div className="flex justify-center pt-4">
                                                        <QRCode value={window.location.origin + '/' + this.state.param.id +'/' + item.kode} size="130" />
                                                    </div>
                                                    <div className="text-center py-3">{item.judul}</div>
                                                    <div className="grid grid-cols-3">
                                                        <div className="cursor-pointer" onClick={() => this.onShare(window.location.origin + '/' + this.state.param.id + '/' + item.kode)}>
                                                            <div className="justify-center items-center flex">
                                                                <svg className='h-6 w-6' viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path fillRule="evenodd" clipRule="evenodd" d="M18.25 9.5C18.25 7.70507 19.7051 6.25 21.5 6.25C23.2949 6.25 24.75 7.70507 24.75 9.5C24.75 11.2949 23.2949 12.75 21.5 12.75C20.5404 12.75 19.6779 12.3341 19.083 11.6727L16.3657 13.1549L13.3251 14.8923C13.5955 15.3664 13.75 15.9152 13.75 16.5C13.75 16.7963 13.7103 17.0834 13.636 17.3562L19.083 20.3273C19.6779 19.6659 20.5404 19.25 21.5 19.25C23.2949 19.25 24.75 20.7051 24.75 22.5C24.75 24.2949 23.2949 25.75 21.5 25.75C19.7051 25.75 18.25 24.2949 18.25 22.5C18.25 22.2036 18.2897 21.9166 18.364 21.6438L12.917 18.6727C12.3221 19.3341 11.4596 19.75 10.5 19.75C8.70507 19.75 7.25 18.2949 7.25 16.5C7.25 14.7051 8.70507 13.25 10.5 13.25C11.1507 13.25 11.7567 13.4412 12.2649 13.7705L15.6343 11.8451L18.364 10.3562C18.2897 10.0834 18.25 9.79635 18.25 9.5ZM21.5 7.75C20.5335 7.75 19.75 8.5335 19.75 9.5C19.75 10.4665 20.5335 11.25 21.5 11.25C22.4665 11.25 23.25 10.4665 23.25 9.5C23.25 8.5335 22.4665 7.75 21.5 7.75ZM10.5 14.75C9.5335 14.75 8.75 15.5335 8.75 16.5C8.75 17.4665 9.5335 18.25 10.5 18.25C11.4665 18.25 12.25 17.4665 12.25 16.5C12.25 15.5335 11.4665 14.75 10.5 14.75ZM19.75 22.5C19.75 21.5335 20.5335 20.75 21.5 20.75C22.4665 20.75 23.25 21.5335 23.25 22.5C23.25 23.4665 22.4665 24.25 21.5 24.25C20.5335 24.25 19.75 23.4665 19.75 22.5Z" fill="#2BC239" />
                                                                </svg>
                                                            </div>


                                                            <div className="justify-center items-center flex">
                                                                <a className="text-black text-sm text-center text-[10px]">Share</a>
                                                            </div>

                                                        </div>

                                                        <div className="cursor-pointer">
                                                            <div className="justify-center items-center flex" onClick={() => { this.props.navigate('/profile/setting-etalase/content/' + item.kode + '/') }}>
                                                                <svg className='h-6 w-6' viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M15.5312 23.0199L15.2583 22.3213L15.5312 23.0199ZM11.4748 23.7988L11.0998 24.4483L11.0998 24.4483L11.4748 23.7988ZM10.1212 19.8964L9.37971 20.0093L10.1212 19.8964ZM10.6115 17.2941L11.261 17.6691L10.6115 17.2941ZM10.0273 18.5314L9.29028 18.3925H9.29028L10.0273 18.5314ZM17.5397 21.2941L18.1892 21.6691L17.5397 21.2941ZM16.7602 22.4186L17.249 22.9875H17.249L16.7602 22.4186ZM14.4099 10.715L13.7604 10.34L14.4099 10.715ZM20.6886 14.34L16.8901 20.9191L18.1892 21.6691L21.9876 15.09L20.6886 14.34ZM11.261 17.6691L15.0594 11.09L13.7604 10.34L9.96194 16.9191L11.261 17.6691ZM15.2583 22.3213C14.1618 22.7497 13.415 23.0394 12.8385 23.1741C12.2817 23.3042 12.029 23.2527 11.8498 23.1493L11.0998 24.4483C11.7531 24.8255 12.4539 24.8044 13.1798 24.6348C13.8861 24.4698 14.7513 24.1298 15.8041 23.7184L15.2583 22.3213ZM9.37971 20.0093C9.5499 21.1267 9.68805 22.046 9.89829 22.7402C10.1144 23.4536 10.4465 24.0712 11.0998 24.4483L11.8498 23.1493C11.6706 23.0458 11.4997 22.8527 11.3339 22.3054C11.1623 21.7388 11.0399 20.9472 10.8626 19.7835L9.37971 20.0093ZM9.96194 16.9191C9.64012 17.4765 9.38246 17.9033 9.29028 18.3925L10.7643 18.6702C10.7983 18.49 10.888 18.3151 11.261 17.6691L9.96194 16.9191ZM10.8626 19.7835C10.7503 19.046 10.7304 18.8505 10.7643 18.6702L9.29028 18.3925C9.1981 18.8817 9.2828 19.373 9.37971 20.0093L10.8626 19.7835ZM16.8901 20.9191C16.5172 21.5651 16.4105 21.7303 16.2715 21.8498L17.249 22.9875C17.6266 22.6631 17.8674 22.2265 18.1892 21.6691L16.8901 20.9191ZM15.8041 23.7184C16.4036 23.4842 16.8714 23.3119 17.249 22.9875L16.2715 21.8498C16.1324 21.9693 15.953 22.0498 15.2583 22.3213L15.8041 23.7184ZM19.499 9.90045C20.3339 10.3825 20.8939 10.7076 21.2797 11.0054C21.6483 11.2898 21.7658 11.4814 21.8135 11.6595L23.2623 11.2712C23.0956 10.649 22.6976 10.2048 22.1961 9.81785C21.7119 9.44416 21.0471 9.06221 20.249 8.60141L19.499 9.90045ZM21.9876 15.09C22.4484 14.2919 22.8331 13.6287 23.0657 13.063C23.3065 12.4771 23.4291 11.8934 23.2623 11.2712L21.8135 11.6595C21.8612 11.8375 21.8553 12.0621 21.6783 12.4928C21.493 12.9436 21.1706 13.5052 20.6886 14.34L21.9876 15.09ZM20.249 8.60141C19.4509 8.1406 18.7877 7.7559 18.222 7.52337C17.6361 7.28257 17.0524 7.15997 16.4302 7.32668L16.8184 8.77557C16.9964 8.72787 17.2211 8.73376 17.6518 8.91076C18.1025 9.09604 18.6641 9.41844 19.499 9.90045L20.249 8.60141ZM15.0594 11.09C15.5414 10.2552 15.8666 9.69516 16.1643 9.30931C16.4488 8.9407 16.6404 8.82327 16.8184 8.77557L16.4302 7.32668C15.808 7.49339 15.3638 7.89142 14.9768 8.39291C14.6031 8.87716 14.2212 9.54189 13.7604 10.34L15.0594 11.09ZM21.7131 14.0655L14.7849 10.0655L14.0349 11.3645L20.9631 15.3645L21.7131 14.0655Z" fill="#414141" />
                                                                </svg>
                                                            </div>

                                                            <div className="justify-center items-center flex">
                                                                <a className="text-black text-sm text-center text-[10px]">Edit</a>
                                                            </div>
                                                        </div>

                                                        <div className="cursor-pointer">
                                                            <div className="justify-center items-center flex" onClick={() => { this.deleteEtalase(item) }}>
                                                                <svg className='h-6 w-6' viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M22.5172 16.7795L23.26 16.8829L22.5172 16.7795ZM22.2549 18.6645L22.9977 18.7679L22.2549 18.6645ZM9.74514 18.6645L10.488 18.5611L9.74514 18.6645ZM9.4828 16.7795L8.73996 16.8829L9.4828 16.7795ZM13.1836 25.7368L12.8921 26.4278L13.1836 25.7368ZM10.4751 22.5603L11.1791 22.3017L10.4751 22.5603ZM21.5249 22.5603L22.2289 22.819V22.819L21.5249 22.5603ZM18.8164 25.7368L18.5248 25.0458H18.5248L18.8164 25.7368ZM9.74664 12.9291C9.70746 12.5167 9.34142 12.2142 8.92906 12.2534C8.5167 12.2925 8.21418 12.6586 8.25336 13.0709L9.74664 12.9291ZM23.7466 13.0709C23.7858 12.6586 23.4833 12.2925 23.0709 12.2534C22.6586 12.2142 22.2925 12.5167 22.2534 12.9291L23.7466 13.0709ZM24 11.75C24.4142 11.75 24.75 11.4142 24.75 11C24.75 10.5858 24.4142 10.25 24 10.25V11.75ZM8 10.25C7.58579 10.25 7.25 10.5858 7.25 11C7.25 11.4142 7.58579 11.75 8 11.75V10.25ZM20 11V11.75H20.75V11H20ZM12 11H11.25V11.75H12V11ZM21.7744 16.6761L21.512 18.5611L22.9977 18.7679L23.26 16.8829L21.7744 16.6761ZM10.488 18.5611L10.2256 16.6761L8.73996 16.8829L9.0023 18.7679L10.488 18.5611ZM16 25.25C14.4708 25.25 13.9254 25.2358 13.4752 25.0458L12.8921 26.4278C13.6891 26.7642 14.6056 26.75 16 26.75V25.25ZM9.0023 18.7679C9.282 20.7777 9.43406 21.9017 9.77109 22.819L11.1791 22.3017C10.9116 21.5736 10.7785 20.6488 10.488 18.5611L9.0023 18.7679ZM13.4752 25.0458C12.5528 24.6566 11.695 23.7058 11.1791 22.3017L9.77109 22.819C10.3857 24.4918 11.4821 25.8328 12.8921 26.4278L13.4752 25.0458ZM21.512 18.5611C21.2215 20.6488 21.0884 21.5736 20.8209 22.3017L22.2289 22.819C22.5659 21.9017 22.718 20.7777 22.9977 18.7679L21.512 18.5611ZM16 26.75C17.3944 26.75 18.3109 26.7642 19.1079 26.4278L18.5248 25.0458C18.0746 25.2358 17.5292 25.25 16 25.25V26.75ZM20.8209 22.3017C20.305 23.7058 19.4472 24.6566 18.5248 25.0458L19.1079 26.4278C20.5179 25.8328 21.6143 24.4918 22.2289 22.819L20.8209 22.3017ZM10.2256 16.6761C10.0035 15.08 9.83766 13.887 9.74664 12.9291L8.25336 13.0709C8.34819 14.069 8.51961 15.2995 8.73996 16.8829L10.2256 16.6761ZM23.26 16.8829C23.4804 15.2995 23.6518 14.069 23.7466 13.0709L22.2534 12.9291C22.1623 13.887 21.9965 15.08 21.7744 16.6761L23.26 16.8829ZM24 10.25H8V11.75H24V10.25ZM19.25 10V11H20.75V10H19.25ZM20 10.25H12V11.75H20V10.25ZM12.75 11V10H11.25V11H12.75ZM16 6.75C17.7949 6.75 19.25 8.20507 19.25 10H20.75C20.75 7.37665 18.6234 5.25 16 5.25V6.75ZM16 5.25C13.3766 5.25 11.25 7.37665 11.25 10H12.75C12.75 8.20507 14.2051 6.75 16 6.75V5.25Z" fill="#F51212" />
                                                                </svg>
                                                            </div>

                                                            <div className="justify-center items-center flex" onClick={() => { this.deleteEtalase(item) }}>
                                                                <a className="text-black text-sm text-center text-[10px]">Delete</a>
                                                            </div>

                                                        </div>

                                                    </div>
                                                </div>
                                            )
                                        })}
                                        
                                    </div>


                                </div>
                            </div>
                        }
                        {/* <form>
            <div className="mb-6">
              <label for="fullname" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-800">Nama Lengkap</label>
              <input type="text" id="fullname" value={this.state.nama} onChange={event => this.setState({ nama : event.target.value})} className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-50 dark:border-gray-600 dark:placeholder-gray-400 dark:text-gray-900 dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light" placeholder="Masukkan Nama Lengkap" required />
            </div>
            <div className="mb-6">
              <label for="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-800">Email Akun</label>
              <input type="email" id="email" value={this.state.data.email} className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-50 dark:border-gray-600 dark:placeholder-gray-400 dark:text-gray-900 dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light" placeholder="Masukkan Email" required />
            </div>
            <div className="mb-6">
              <label for="password" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-800">Kata Sandi</label>
              <input type="password" id="password" className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-50 dark:border-gray-600 dark:placeholder-gray-400 dark:text-gray-900 dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light" required />
            </div>
            <div className="mb-6">
              <label for="phone" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-800">No. Handphone</label>
              <input type="text" id="phone" value={this.state.phone} className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-50 dark:border-gray-600 dark:placeholder-gray-400 dark:text-gray-900 dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light" placeholder="Masukkan Phone Number" required onChange={event => this.setState({ phone : event.target.value})} />
            </div>
            <div className="mb-6">
              <label for="birthdate" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-800">Tanggal Lahir</label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                  <svg className="w-5 h-5 text-gray-500 dark:text-gray-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd"></path></svg>
                </div>
                <input type="date" value={this.state.tglLahir} className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5 dark:bg-gray-50 dark:border-gray-600 dark:placeholder-gray-400 dark:text-gray-900 dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Select date" />
              </div>
            </div>
            <div className="flex justify-end">
              <button onClick={this.simpanProfile} type="button" className="w-4/12 bg-greenWalang font-medium rounded-full text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-[#3b5998]/55 justify-center mr-2">
                <div className="text-[#ffffff]">
                  Simpan
                </div>
              </button>
            </div>
            
          </form>
         */}
                    </div>

                }
            </div>
        );

    }
}

function WithNavigate(props) {
    let navigate = useNavigate();
    return <Outlet {...props} navigate={navigate} params={useParams()} />
}

export default WithNavigate;
